export enum RETURN_TYPES {
	HOME_PICK_UP = 'homePickUp',
	DROPPOINT = 'dropPoint',
	MAIL = 'returnByMail',
	SHOP = 'returnInStore',
	PREPAID_RETURN_LABEL = 'prepaidReturnLabel',
	COLLECTION_POINT_WITHOUT_REQUEST = 'pickUpPointWithoutRequest',
	HOME_PICK_UP_WITHOUT_REQUEST = 'homePickUpWithoutRequest',
}
